import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import { OrderRequestFiles } from "../../../request-details-files.component";
import { RequestOnBehalfDetails } from "../../../request-on-behalf-details.component";
import Translation from "../../../../../../common/translation/translation.component";

export class NewCircuitExhibitBDetails extends Component {
    constructor(props) {
        super(props);
    }

    handleShow = () => {
        this.setState({
            show: true
        });
    }

    render() {
        const { data } = this.props;
        return (
            <div>              
                <h4 className="order-detail-title"><Translation translationKey="order_request_details" /></h4>
                <div className="order-detail-location">
                    <RequestOnBehalfDetails robDetails={data.RequestedInBeHalfOf} isRob={data.Order.IsRequestedInBehalf} />
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="order_number" /></td>
                                <td>{data.Order.OrderNumber}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="capital_location" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="country" /></td>
                                <td>{data.Location.CountryName}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="delivery_address" /></td>
                                <td>{data.Location.LocationName}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="company_code" /></td>
                                <td>{data.Order.CostCenter}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="subscription_upper" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="vendor" /></td>
                                <td>{data.Subscription.Vendor}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="commodity_code" /></td>
                                <td>{data.Subscription.Plan}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="pricing_details" /></td>
                                <td>{data.Subscription.PlanDetails.PlanComponentName} {(data.Subscription.PlanDetails.Monthly / data.Subscription.Quantity).toFixed(2)} {data.Subscription.PlanDetails.Currency.CurrencyName} per month</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="quantity" /></td>
                                <td>{data.Subscription.Quantity}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="total_cost" /></td>
                                <td>{data.Subscription.TotalCost}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title">
                        <Translation translationKey="capital_business_justification" />
                    </h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="approver" /></td>
                                <td>{data?.BusinessWireline?.WirelineApproverName}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="purpose_of_use" /></td>
                                <td>{data.BusinessJustification.PurposeOfUse}</td>
                            </tr>
                            <tr>
                                {/*<td><Translation translationKey="additional_information" /></td>*/}
                                {/*<td>{data.BusinessJustification.AdditionalInformation}</td>*/}
                            </tr>
                        </tbody>
                    </Table>
                    <OrderRequestFiles files={data.Order.OrderFileNames} />
                </div>
            </div>
        );
    }
}